var map = {
	"./pic1.png": "ba90",
	"./pic2.png": "aac3",
	"./pic3.png": "1777",
	"./pic4.png": "e708",
	"./pic5.png": "edfa",
	"./pica1.png": "7801",
	"./pica2.png": "6526",
	"./pica3.png": "1130",
	"./pica4.png": "ce35",
	"./pica5.png": "829d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9eb2";